module.exports = __webpack_public_path__ + "img/detect.0a08501c.webp";